class LocalStorageHandler {

  async write(key, value) {
    // Todo: Encrypt
    localStorage.setItem(key, JSON.stringify(value));
  }

  read(key) {
    const item = localStorage.getItem(key);
    if (item !== "undefined") {
      // Todo: Decrypt
      return JSON.parse(item)
    } else {
      return {};
    }
  }
}

export default LocalStorageHandler;
